// Shared metadata-only URL policy. No Slack discovery or connector access.
export const SLACK_URL_ERROR = "Enter a valid HTTPS Slack URL, or leave this field blank.";
export const SLACK_INVITE_HINT = "Invite link. A channel link (…/archives/C…) opens directly for members.";

const SLACK_HOST = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)*slack\.com$/;
const ARCHIVE_PATH = /^\/archives\/([CG][A-Z0-9]+)(?:\/p\d+)?\/?$/;
const CLIENT_PATH = /^\/client\/[TE][A-Z0-9]+\/([CG][A-Z0-9]+)\/?$/;
const INVITE_PATH = /^\/share\/[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*\/?$/;

function channelId(url) {
  return ARCHIVE_PATH.exec(url.pathname)?.[1] || CLIENT_PATH.exec(url.pathname)?.[1] || null;
}

export function parseSlackHttpsUrl(value) {
  if (typeof value !== "string") return null;
  const text = value.trim();
  if (!text || /[\s\\]/.test(text) || !/^https:\/\//i.test(text)) return null;
  try {
    const url = new URL(text);
    const host = url.hostname;
    const slackHost = SLACK_HOST.test(host);
    const supportedPath = channelId(url) || (host === "join.slack.com" && INVITE_PATH.test(url.pathname));
    // Do not let URL normalization turn a malformed path into a channel link.
    const [, authority, rawPath] = /^https:\/\/([^/?#]+)([^?#]*)/i.exec(text) || [];
    return url.protocol === "https:" && slackHost && supportedPath && rawPath === url.pathname
      && !authority.includes("@") && !url.username && !url.password && !url.port ? url : null;
  } catch { return null; }
}

// Legacy values may be read unchanged, but this URL-entry slice cannot add them.
export function validSlackWrite(value) {
  return value === null || (typeof value === "string" && (!value.trim() || Boolean(parseSlackHttpsUrl(value))));
}

export function isSlackInvite(value) {
  const url = parseSlackHttpsUrl(value);
  return Boolean(url && url.hostname === "join.slack.com" && INVITE_PATH.test(url.pathname));
}

export function slackChannelId(value) {
  const url = parseSlackHttpsUrl(value);
  return url ? channelId(url) : null;
}
